import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable, from, combineLatest } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-promo-image-header',
  templateUrl: './promo-image-header.component.html',
  styleUrls: ['./promo-image-header.component.scss']
})
export class PromoImageHeaderComponent implements OnInit {
  happy1$: Observable<string>;
  happy2$: Observable<string>;
  loading = true;

  constructor(private firebaseStorage: AngularFireStorage) {}

  ngOnInit(): void {
    this.happy1$ = from(
      this.firebaseStorage.storage.ref('happy1.jpg').getDownloadURL()
    );
    this.happy2$ = from(
      this.firebaseStorage.storage.ref('happy2.jpg').getDownloadURL()
    );

    combineLatest([this.happy1$, this.happy2$])
      .pipe(delay(50))
      .subscribe(() => (this.loading = false));
  }
}
